import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  footerBg: {
    background: 'var(--color-black)',
    color: 'var(--color-neutral-gray-light)',
    minHeight: '200px',
    width: '100%',
},
footerContent: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
},
// .footerContent>*{
//     padding: 6px;
// }
contact: {},
contactMail: {
    margin: '2px',
    color: 'rgb(218, 213, 213)',
    fontSize: '18px',
},
contactNumber: {
    color: 'rgb(225, 192, 192)',
    fontSize: '15px',
    [theme.breakpoints.down('xs')]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
},
copyRight: {
    fontSize: '14px',
    fontStyle: 'italic',
},
socialIcon: {
    marginTop: '50px',
    padding: '10px',
    marginBottom: 20,
},
footerIcon: {
    fontSize: '30px',
    color: 'rgb(201, 198, 198)',
    margin: '0 5px',
    padding: '5px',
}
}));

export default useStyles;
